import React from 'react';
import {classes} from './CheckoutButton.st.css';
import classnames from 'clsx';
import {useControllerProps} from '../../../domain/controllers/ControllerContext';
import {StatesButtonStates, ThreeDotsLoader, StatesButton, Button, ButtonPriority} from '@wix/wix-ui-tpa/cssVars';
import {SECURE_CHECKOUT_ID} from '../SecureCheckout/SecureCheckout';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {SPECS} from '../../../domain/specs';
import {isCartV2} from '../../../domain/utils/isCartV2.utils';

export enum CheckoutButtonDataHook {
  button = 'CheckoutButtonDataHook.button',
  threeDotsLoader = 'CheckoutButtonDataHook.threeDotsLoader',
}

export interface CheckoutButtonProps {
  disabled?: boolean;
  priority?: ButtonPriority;
  text: string;
  isNavigationToCheckoutInProcess?: boolean;
  className?: string;
}

export function CheckoutButton({
  disabled,
  priority,
  text,
  isNavigationToCheckoutInProcess,
  className,
}: CheckoutButtonProps) {
  const {handleCheckoutButtonClickOld, handleCheckoutButtonHover, checkoutUrl, handleCheckoutButtonClick} =
    useControllerProps().navigationStore;
  const {isPickup} = useControllerProps().orderStore;
  const {experiments} = useExperiments();
  const {cartModel} = useControllerProps().cartStore;

  if (experiments.enabled(SPECS.CheckoutButtonWithHrefInCart) && isCartV2(cartModel.id) && checkoutUrl) {
    return (
      <Button
        href={isPickup ? `${checkoutUrl}&isPickupFlow=true` : checkoutUrl}
        as="a"
        priority={priority}
        aria-labelledby={SECURE_CHECKOUT_ID}
        className={classnames(classes.customizableCheckoutButton, disabled && classes.buttonDisabled, className)}
        data-hook={CheckoutButtonDataHook.button}
        data-wix-checkout-button={CheckoutButtonDataHook.button}
        onClick={() => handleCheckoutButtonClick()}
        onMouseEnter={() => handleCheckoutButtonHover()}
        disabled={disabled}
        upgrade>
        {text}
      </Button>
    );
  }

  return (
    <StatesButton
      aria-labelledby={SECURE_CHECKOUT_ID}
      priority={priority}
      className={classnames(classes.customizableCheckoutButton, className)}
      data-hook={CheckoutButtonDataHook.button}
      data-wix-checkout-button={CheckoutButtonDataHook.button}
      disabled={disabled}
      state={isNavigationToCheckoutInProcess ? StatesButtonStates.IN_PROGRESS : StatesButtonStates.IDLE}
      onClick={() => {
        return handleCheckoutButtonClickOld();
      }}
      onMouseEnter={() => {
        return handleCheckoutButtonHover();
      }}
      inProgressContent={
        <ThreeDotsLoader data-hook={CheckoutButtonDataHook.threeDotsLoader} className={classes.threeDotButton} />
      }
      idleContent={text}
      upgrade
    />
  );
}
